import { ComparisonCardProps } from './modules'



const ComparisonCard = ({ title, value, percentage, trend, beforeMYT }: ComparisonCardProps) => {
    return (
        <div className="space-y-2 border border-gray-300 p-3 rounded-lg bg-white shadow-sm hover:shadow-md transition-shadow">
            <div className="text-xs font-medium text-gray-700">{title}</div>
            <div>
                <div className="flex justify-between items-center">
                    <div className="text-2xl md:text-3xl font-bold">{value}</div>
                    {trend !== 'none' && (
                        <div className="flex items-center space-x-1">
                            <span className={percentage.includes('-') ? 'text-red-600' : 'text-green-600'}>
                                {percentage}
                            </span>
                            {trend === 'up' ? (
                                <svg className="w-3 h-3 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                                </svg>
                            ) : (
                                <svg className="w-3 h-3 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
                                </svg>
                            )}
                        </div>
                    )}
                </div>
                <div className="text-xs text-gray-500 flex space-x-1">
                    <span>Before MYT:</span>
                    <span>{beforeMYT}</span>
                </div>
            </div>
        </div>
    )
}

export default ComparisonCard